export const MAX_RISK = 7;
export const RISK_DATA = {
	HIGH: {
		text: 'Nagy',
		color: 'dark'
	},
	AVERAGE: {
		text: 'Átlagos',
		color: 'light'
	},
	LOW: {
		text: 'Kicsi',
		color: 'green'
	}
};

export const TOOLTIPS = {
	RISK: 'A befektetési alapokat kockázati szintjük alapján hét kategóriába soroljuk. Egy magasabb kockázatú alappal ugyan optimális esetben nagyobb nyereség érhető el, de egy alacsonyabb kockázatú alappal szemben nagyobb az esélye a veszteségnek is.',
	LOW_RISK: 'Minimális (1) és alacsony (2) kockázati besorolású befektetési jegyek tartoznak ebbe a csoportba',
	MEDIUM_RISK: 'Mérsékelt (3), közepes (4) és számmottevő (5) kockázati besorolású befektetési jegyek tartoznak ebbe a csoportba',
	HIGH_RISK: 'Jelentős (6) és magas (7) kockázati besorolású befektetési jegyek tartoznak ebbe a csoportba',
	CURRENCY:
		'Ahhoz, hogy külföldi piacokon fektess be nem szükséges devizát váltanod, csupán olyan befektetési alapot választani, amely külföldi piacon működik.'
};

export const SORTING_OPTIONS = [
	{ value: 'Név szerint - A-Z', key: 'nameAscending' },
	{ value: 'Név szerint - Z-A', key: 'nameDescending' },
	{ value: 'Legalacsonyabb kockázat elöl', key: 'lowestRiskFirst' },
	{ value: 'Legmagasabb kockázat elöl', key: 'highestRiskFirst' },
	{ value: 'Befektetési időtáv szerint növekvő', key: 'investmentPeriodIncreasing' },
	{ value: 'Befektetési időtáv szerint csökkenő', key: 'investmentPeriodDecreasing' },
	{ value: '1 éves múltbeli hozamok szerint', key: 'oneYearYield' },
	{ value: '3 éves múltbeli hozamok szerint', key: 'threeYearYield' },
	{ value: '5 éves múltbeli hozamok szerint', key: 'fiveYearYield' }
];
